import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/auth";
import { useHomeContext } from "../../context/HomeContext";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useThemeContext } from "../../context/ThemeContext";
const Banner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const { currentMode } = useThemeContext();
  const [bannerId, setBannerId] = useState(null);
  const [acceptedBannerId, setAcceptedBannerId] = useState(null);
  const navigate = useNavigate();
  const [unAcceptedBanners, setUnAcceptedBanners] = useState([]);
  const [acceptedBanners, setAcceptedBanners] = useState([]);
 
  const { token, user } = useAuth();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  const unAcceptedBannerAdsData = useQuery(
    ["unAcceptedBannerAdsDataApi", isModalOpen, bannerId, acceptedBannerId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/unaccepted/all`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setUnAcceptedBanners(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );

  const acceptedBannerAdsData = useQuery(
    ["acceptedBannerAdsDataApi", bannerId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/accepted/all`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setAcceptedBanners(
          res?.data?.data?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );

  //acccept requrest
  const handleAccept = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to accept the request this banner ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  setAcceptedBannerId(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  //delete banner
  const handleDelete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to delete this banner ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  deleteBannerMutationHandler(id);
                  onClose();
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const acceptBannerAds = useQuery(
    ["acceptBannerAdsDataApi", acceptedBannerId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}banner/company/accept/${acceptedBannerId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!acceptedBannerId,
      onSuccess: (res) => {
        toast.info(
          "banner ads request accepted successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setAcceptedBannerId(null);
      },
    }
  );
  const bannerDeleteMutation = useMutation(
    async (id) =>
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}banner/company/delete/${id}`
      ),
    {
      retry: false,
    }
  );
  const deleteBannerMutationHandler = async (id) => {
    try {
      bannerDeleteMutation.mutate(id, {
        onSuccess: (responseData) => {
          toast.info(
            "banner deleted successfully",
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setBannerId(null);
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message,
            { theme: "colored" },
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  const unAcceptedBannerColumns = [
    { field: "index", headerName: "ID", width: 50, headerAlign: "left" },
    {
      field: "image",
      headerName: "Image",
      width: 170,
      renderCell: (params) => {
        return (
          <img
            src={params?.row?.image}
            alt=""
            className="h-24 w-full object-cover rounded-md py-2"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 200,
      renderCell: (params) => {
        return <h1>{params?.row?.owner?.name}</h1>;
      },
    },

    {
      field: "isAccepted",
      headerName: "isAccepted",
      width: 100,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isRejected",
      headerName: "isRejected",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex items-center space-x-3">
            <button
              onClick={() => {
                navigate("/banner/detail/" + params.row._id);
              }}
              className="bg-blue-bg rounded-sm text-center
                         px-3 p-1 font-medium text-sm text-white capitalize"
            >
              Detail
            </button>
            <button
              onClick={() => {
                handleDelete(params.row._id);
                setBannerId(params.row._id);
              }}
              className="bg-red-500 rounded-sm text-center
                         px-3 p-1 font-medium text-sm text-white capitalize"
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  //accepted column
  const acceptedBannerColumns = [
    { field: "index", headerName: "ID", width: 50, headerAlign: "left" },
    {
      field: "image",
      headerName: "Image",
      width: 170,
      renderCell: (params) => {
        return (
          <img
            src={params?.row?.image}
            alt=""
            className="h-24 w-full object-cover rounded-md py-2"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 200,
      renderCell: (params) => {
        return <h1>{params?.row?.owner?.name}</h1>;
      },
    },

    {
      field: "isAccepted",
      headerName: "isAccepted",
      width: 100,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isRejected",
      headerName: "isRejected",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "action",
      headerName: "action",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="flex items-center space-x-3">
            <button
              onClick={() => {
                navigate("/banner/detail/" + params.row._id);
              }}
              className="bg-blue-bg rounded-sm text-center
                         px-3 p-1 font-medium text-sm text-white capitalize"
            >
              Detail
            </button>
            <button
              onClick={() => {
                handleDelete(params.row._id);
                setBannerId(params.row._id);
              }}
              className="bg-red-500 rounded-sm text-center
                         px-3 p-1 font-medium text-sm text-white capitalize"
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        // color="secondary"
        // variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        // @ts-expect-error
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  return (
    <div className="p-3 md:p-5">
      <div className="py-3">
        <nav className="flex" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <Link
                to="/"
                className="inline-flex items-center  font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
              >
                Dashboard
              </Link>
            </li>
            <li>
              <div className="flex items-center">
                <svg
                  className="w-6 h-6 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="ml-1  font-medium text-gray-500 md:ml-2 dark:text-gray-400">
                  Banner Ads
                </span>
              </div>
            </li>
          </ol>
        </nav>
      </div>

      {/* banners */}
      <div className="bg-white dark:bg-secondary-dark-bg p-2 md:p-5 rounded-lg">
        {/* <div className="flex items-end justify-end py-4">
          <button
            onClick={() => setIsModalOpen(true)}
            className="p-2 px-7 bg-[#216fed] font-medium text-white rounded-md hover:opacity-80"
          >
            + Post Banner Ads
          </button>
        </div> */}

        {/* accepted ads */}
        <div className="flex flex-col items-start space-y-2">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Banner Ads Request
          </h1>
          <div className="w-full">
            {unAcceptedBannerAdsData.isFetched ? (
              unAcceptedBannerAdsData?.data?.data?.data?.length > 0 ? (
                unAcceptedBanners?.length > 0 ? (
                  <div style={{ height: 530 }} className="">
                    <DataGrid
                      rows={unAcceptedBanners}
                      columns={unAcceptedBannerColumns}
                      pageSize={4}
                      rowsPerPageOptions={[5]}
                      disableSelectionOnClick
                      getRowId={(row) => row._id}
                      getRowHeight={() => "auto"}
                      sx={{
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                        "& .super-app-theme--header": {
                          borderColor:
                            currentMode === "Dark" ? "#475569" : "#64748b",
                          border: "none",
                        },
                        color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                        border: 2,
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        [`& .${gridClasses.cell}`]: {
                          borderColor: (theme) =>
                            currentMode === "Dark" ? "#475569" : "#64748b",
                        },
                        [`& .${gridClasses.row}`]: {
                          borderColor: (theme) =>
                            currentMode === "Dark" ? "#475569" : "#64748b",
                          textAlign: "center",
                        },
                        "& .MuiDataGrid-cellCenter": {
                          justifyContent: "center",
                        },
                        "&.MuiDataGrid-root .MuiDataGrid-cell": {
                          outline: "none",
                          textAlign: "left",
                          border: "none",
                        },
                        "& .MuiPaginationItem-root": {
                          color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                          // backgroundColor:'red'
                          border: "none",
                        },
                      }}
                      components={{
                        Pagination: CustomPagination,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <ThreeDots
                      height="80"
                      width="80"
                      radius="9"
                      color="#216fed"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                )
              ) : (
                <div className="flex items-center justify-center w-full text-center">
                  <h1 className="capitalize text-dark-gray text-2xl font-bold text-center">
                    You have no Ads Request
                  </h1>
                </div>
              )
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
        {/* accepted banner */}
        <div className="flex flex-col items-start space-y-2 pt-5">
          <h1 className="text-dark-color dark:text-white font-bold text-2xl">
            Accepted Banner Ads
          </h1>
          <div className="w-full">
            {acceptedBannerAdsData.isFetched ? (
              acceptedBannerAdsData?.data?.data?.data?.length > 0 ? (
                acceptedBanners?.length > 0 ? (
                  <div style={{ height: 530 }} className="">
                    <DataGrid
                      rows={acceptedBanners}
                      columns={acceptedBannerColumns}
                      pageSize={8}
                      rowsPerPageOptions={[5]}
                      disableSelectionOnClick
                      getRowId={(row) => row._id}
                      getRowHeight={() => "auto"}
                      sx={{
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                        "& .super-app-theme--header": {
                          borderColor:
                            currentMode === "Dark" ? "#475569" : "#64748b",
                          border: "none",
                        },
                        color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                        border: 2,
                        borderColor:
                          currentMode === "Dark" ? "#475569" : "#64748b",
                        [`& .${gridClasses.cell}`]: {
                          borderColor: (theme) =>
                            currentMode === "Dark" ? "#475569" : "#64748b",
                        },
                        [`& .${gridClasses.row}`]: {
                          borderColor: (theme) =>
                            currentMode === "Dark" ? "#475569" : "#64748b",
                          textAlign: "center",
                        },
                        "& .MuiDataGrid-cellCenter": {
                          justifyContent: "center",
                        },
                        "&.MuiDataGrid-root .MuiDataGrid-cell": {
                          outline: "none",
                          textAlign: "left",
                          border: "none",
                        },
                        "& .MuiPaginationItem-root": {
                          color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                          // backgroundColor:'red'
                          border: "none",
                        },
                      }}
                      components={{
                        Pagination: CustomPagination,
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <ThreeDots
                      height="80"
                      width="80"
                      radius="9"
                      color="#216fed"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                )
              ) : (
                <div className="flex items-center justify-center w-full text-center">
                  <h1 className="capitalize text-dark-gray text-2xl font-bold text-center">
                    You have no Banner Ads
                  </h1>
                </div>
              )
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
      />
    </div>
  );
};

export default Banner;

{
  /* <div>
{unAcceptedBannerAdsData.isFetched ? (
   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
     {unAcceptedBannerAdsData?.data?.data?.data?.map((item)=>(
        <div className="flex flex-col items-start space-y-1">
            <img src={item.image} alt="" />
            <p>isAccepted:{item.isAccepted.toString()}</p>
        </div>
    ))}
   </div>
):(
    <div className="flex items-center justify-center">
    <ThreeDots
      height="80"
      width="80"
      radius="9"
      color="#216fed"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  </div>
)}
</div> */
}
